import { AppTours, DashboardIntroCard, DashboardLink, DashboardWrapper, tourSteps } from '@modules/app';
import { Col, Row } from 'antd';
import { themeConfig } from '@theme/index';

export const StudentDashboard = () => {
  return (
    <DashboardWrapper>
      <AppTours steps={tourSteps.student} />

      <DashboardIntroCard className="intro-card" />

      <div className="dashboard-inner" id="dashboard-quick-links">
        <Row gutter={themeConfig.grid.formInputRowGutter}>
          <Col sm={12} md={8}>
            <DashboardLink iconName="calendar_today" linkText="Timetable" link="/timetable" />
          </Col>

          <Col sm={12} md={8}>
            <DashboardLink iconName="menu_book" linkText="LMS" link="/lms/student/subjects" />
          </Col>

          <Col sm={12} md={8}>
            <DashboardLink iconName="list_alt" linkText="Assessments" link="/assessments" />
          </Col>
        </Row>
      </div>
    </DashboardWrapper>
  );
};
